import { getEnabledFeatures, getEntity } from "data/entity";
import { List, Map } from "immutable";
import { stripCommas } from "lib/utils/numberFunctions";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Field, formValueSelector } from "redux-form";

import { getCampaign } from "data/parent-campaign";
import LanguageSelector from "../components/LanguageSelector";

import { getBillingType } from "data/giving-form/billing";

import {
  fetchAllocations,
  getAllocationType,
  getAllocations,
  getAmountWithGiftAid,
  getCentralizedGifts,
  getGatewayError,
  getHasMounted,
  getIsGiftAid,
  getMinimumValueError,
  getSelectedAllocations,
  getStripePaymentIntentId,
  getStripeToken,
  getTotalAmount,
  setConnectedStripeAccountId,
  setIsGiftAid,
  setMinimumValueError,
  setNewAmount,
  setStripeClientSecretKey,
  setStripePaymentIntentId,
  setStripePublishableKey,
} from "data/giving-form/allocation-selection";

import { setInitialPagination } from "data/pagination";

import { GIVING_FORM_PAGINATION_SCOPE } from "data/giving-form";

import GiftAid from "../components/GiftAid";
import Billing from "../containers/Billing";
import SearchContainer from "../containers/SearchContainer";

import classNames from "classnames";

const MINIMUM_AMOUNT = 1;

class SelectDonationInfo extends React.PureComponent {
  state = {
    loading: true,
    isConfirmedDonationInfo: false,
  };

  handleCloseModal = (e) => {
    const { onCloseModal } = this.props;

    e.preventDefault();
    onCloseModal();
  };

  retriveAccountStripeId(amount) {
    const {
      nextPage,
      entity,
      setConnectedStripeAccountId,
      setStripePaymentIntentId,
      setStripeClientSecretKey,
      setStripePublishableKey,
      dispatch,
    } = this.props;

    const stripeAccountIdPromise = getStripeToken(entity.get("id"), dispatch);

    stripeAccountIdPromise.then((data) => {
      if (!data) {
        return;
      }

      setConnectedStripeAccountId(data.stripe_uid);
      setStripePublishableKey(data.stripe_publishable_key);
      if (!this.state.isConfirmedDonationInfo) {
        this.state.isConfirmedDonationInfo = true;
        nextPage();
      }
    });
  }

  handleNextPage = (e) => {
    const {
      nextPage,
      amount,
      entity,
      setMinimumValueError,
      selectedAllocations,
      isStripePayment,
    } = this.props;
    e.preventDefault();

    window && window.SnapAnalytics && window.SnapAnalytics.paymentInfo();

    let tooSmallDonation = false;
    selectedAllocations.forEach((allocation) => {
      if (allocation.get("amount") < entity.get("min_donation_amount")) {
        tooSmallDonation = true;
      }
    });

    if (amount < entity.get("minimum_giving_day_amount")) {
      setMinimumValueError(
        `Minimum total donation amount of ${entity.get("currency_symbol")}${entity.get(
          "minimum_giving_day_amount",
        )}`,
      );
    } else if (tooSmallDonation) {
      setMinimumValueError(
        `Minimum donation amount per fund of ${entity.get("currency_symbol")}${entity.get(
          "min_donation_amount",
        )}`,
      );
    } else {
      setMinimumValueError("");

      isStripePayment ? this.retriveAccountStripeId(amount) : nextPage();
    }
  };

  disableButton() {
    const { allocationType, causesRequired, allocations, selectedAllocations, amount } =
      this.props;

    if (this.state.isConfirmedDonationInfo) {
      return true;
    }

    if (selectedAllocations.count() >= 1) {
      let hasZero = false;
      selectedAllocations.forEach((allocation) => {
        if (!allocation.get("amount")) {
          hasZero = true;
        }
      });
      if (hasZero) {
        return true;
      }
    }

    if (allocationType == "campaign") {
      return selectedAllocations.count() < 1 || amount < MINIMUM_AMOUNT;
    }

    return (
      (causesRequired && allocations.count() > 0 && selectedAllocations.count() === 0) ||
      amount < MINIMUM_AMOUNT
    );
  }
  componentDidMount() {
    const {
      campaignId,
      allocationType,
      entity,
      hasMounted,
      campaignDefaultAmount,
    } = this.props;
    const { fetchAllocations, setNewAmount, setInitialPagination, totalAmount } =
      this.props;

    this.state.isConfirmedDonationInfo = false;
    window.foo = entity;

    if (!hasMounted) {
      if (window.PersistentCartService) {
        const preTotalAmount = Object.values(
          window.PersistentCartService.allocations(),
        ).reduce((total, amount) => parseFloat(total) + (parseFloat(amount) || 0), 0);
        setNewAmount(`${totalAmount || preTotalAmount}`);
      } else {
        const initialGivingAmount =
          campaignDefaultAmount ?? entity.get("giving_day_amount");

        setNewAmount(initialGivingAmount);
      }
    }

    fetchAllocations(campaignId, allocationType, {
      initialSearch: true,
      page: 1,
      entityId: entity.get("id"),
      fundsPage: -1,
    }).then(({ total }) => {
      setInitialPagination({ total });
      this.setState({
        loading: false,
      });
    });

    window &&
      window.SnapAnalytics &&
      window.SnapAnalytics.track({
        hitType: "event",
        eventCategory: "giving form",
        eventAction: "selectDonationInfo",
      });
  }

  renderGatewayError() {
    const { gatewayError } = this.props;

    if (gatewayError) {
      return (
        <div className="text-danger text-center m-md-a">
          <span>
            {gatewayError} uses a different donation process than your already selected
            campaigns.
          </span>
          <br />
          <span>
            Please finish the donation and come back to donate to {gatewayError}.
          </span>
        </div>
      );
    }
  }

  renderContent() {
    const { dontPreselectCampaign, shellCampaign } = this.props;
    const { loading } = this.state;

    if (loading) {
      return (
        <div key={"spinner"} className="m-p-t m-p-b text-center">
          <i className="fa fa-5x fa-refresh fa-spin" />
        </div>
      );
    }

    return (
      <div className="max-width-100">
        <Billing />
        <SearchContainer
          shellCampaign={shellCampaign}
          dontPreselectCampaign={dontPreselectCampaign}
        />
        {this.renderGatewayError()}
      </div>
    );
  }

  onChangeGiftAid() {
    const { isGiftAid, setIsGiftAid } = this.props;
    setIsGiftAid(!isGiftAid);
  }

  render() {
    const {
      entity,
      allocations,
      minimumValueError,
      isEnabledGiftAid,
      entityName,
      isGiftAid,
      amountWithGiftAid,
      currencySymbol,
      hasConfirmationStep,
      availableLocales,
      selectedLocale,
      handleLanguageChange,
      centralizedGifts,
    } = this.props;

    return (
      <section className="Modal__Content donate-modal primary-color-background">
        <div className="voting-modal-background">
          <button
            data-testid="t-SelectD-modal-close-button"
            aria-label="Modal Close Button"
            className="modal-close-button"
            onClick={this.handleCloseModal}>
            <i className="fa fa-times fa-2x" />
          </button>
          <div className="p-md-b">
            <h2 className="voting-modal-header">
              {entity.get("donation_modal_header") ? (
                entity.get("donation_modal_header")
              ) : (
                <span>
                  <span className="step-active">
                    <FormattedMessage id="giftInformation" />
                  </span>{" "}
                  &gt; <FormattedMessage id="payment" />
                  {hasConfirmationStep ? (
                    <span>
                      {" "}
                      &gt; <FormattedMessage id="confirmation" />
                    </span>
                  ) : (
                    ""
                  )}
                </span>
              )}
            </h2>
          </div>
          <div className="voting-modal-body">
            <div className="donating-steps">
              <span className="step_credit primary-color-text secondary-color-border-bottom-2px">
                <i className="fa fa-gift fa-lg m-sm-r" />
                <FormattedMessage id="gift" />
              </span>

              <LanguageSelector
                availableLocales={availableLocales}
                selectedLocale={selectedLocale}
                handleLanguageChange={handleLanguageChange}
              />
            </div>

            <div className="giving-form-billing">
              <div>{this.renderContent()}</div>
              {isEnabledGiftAid && isGiftAid && amountWithGiftAid > 0 && (
                <GiftAid
                  currencyCode={currencyCode}
                  amountWithGiftAid={amountWithGiftAid}
                  classColor="gray-font-color"
                />
              )}
              {isEnabledGiftAid && (
                <div className="gift-aid">
                  <div>
                    <input
                      data-testid="t-SelectD-giftaid"
                      className="p-sm-b"
                      name="giftAid"
                      checked={isGiftAid}
                      type="checkbox"
                      onChange={this.onChangeGiftAid.bind(this)}
                    />
                  </div>
                  <div className="give-aid-text">
                    <span>
                      Please treat as Gift Aid donations this gift, all gifts made within
                      the past four years, and all future gifts to
                      {` ${entityName}`}. I am a UK taxpayer and understand that if I pay
                      less Income Tax and/or Capital Gains Tax in the relevant tax year
                      than the amount of Gift Aid claimed on all my donations, it is my
                      responsibility to pay any difference back to HMRC.
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>

          <div>
            <button
              data-testid="t-SelectD-submit"
              className="voting-modal-btn secondary-color-background"
              onClick={this.handleNextPage}
              disabled={this.disableButton()}
              title="donation-button"
              type="submit">
              <FormattedMessage id="proceedButton" />
            </button>
            {minimumValueError && (
              <div className="m-sm-t m-sm-b text-center white-font-color">
                {minimumValueError}
              </div>
            )}
          </div>
        </div>
      </section>
    );
  }
}

const selector = formValueSelector("donation");

SelectDonationInfo.propTypes = {
  entity: PropTypes.instanceOf(Map),

  allocationType: PropTypes.string.isRequired,
  selectedAllocations: PropTypes.instanceOf(List),
  allocations: PropTypes.instanceOf(List),
  centralizedGifts: PropTypes.instanceOf(List),
  amount: PropTypes.number.isRequired,
  campaignId: PropTypes.string.isRequired,
  campaignDefaultAmount: PropTypes.number,
  fetchAllocations: PropTypes.func.isRequired,

  dontPreselectCampaign: PropTypes.bool,
  shellCampaign: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    selectedAllocations: getSelectedAllocations(state),
    allocations: getAllocations(state),
    allocationType: getAllocationType(state),
    amount: stripCommas(selector(state, "amount")),
    causesRequired: getCampaign(state)("giving_form").get("causes_required"),
    campaignId: getCampaign(state)("giving_form").get("id"),
    campaignDefaultAmount: getCampaign(state)("giving_form").get("default_amount"),
    entity: getEntity(state),
    gatewayError: getGatewayError(state),
    minimumValueError: getMinimumValueError(state),
    hasMounted: getHasMounted(state),
    isStripePayment: getEnabledFeatures(state).includes("stripe"),
    billingType: getBillingType(state),
    isEnabledGiftAid: getEnabledFeatures(state).includes("gift_aid"),
    isGiftAid: getIsGiftAid(state),
    entityName: getEntity(state).get("name"),
    amountWithGiftAid: getAmountWithGiftAid(state),
    currencySymbol: getEntity(state).get("currency_symbol"),
    isAdditionalGiftEnabled: getEnabledFeatures(state).includes(
      "additional_centralized_gift",
    ),
    totalAmount: getTotalAmount(state),
    centralizedGifts: getCentralizedGifts(state),
    stripePaymentIntentId: getStripePaymentIntentId(state),
  };
};

const mapActionCreators = (dispatch) => {
  return {
    dispatch,
    ...bindActionCreators(
      {
        fetchAllocations,
        setNewAmount,
        setMinimumValueError,
        setConnectedStripeAccountId,
        setStripePaymentIntentId,
        setStripeClientSecretKey,
        setStripePublishableKey,
        setIsGiftAid,
        setInitialPagination({ total }) {
          return setInitialPagination({
            scope: GIVING_FORM_PAGINATION_SCOPE,
            total,
          });
        },
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapActionCreators)(SelectDonationInfo);
